/*
 * The editions list pages like every `/v1` list (`page`, `pageSize`, `sort`), and the server caps
 * `pageSize` at 100, so the page size list must not offer more.
 */
export const GET_EDITIONS_DEFAULT_QUERY_PARAMS = {
	page: 1,
	pageSize: 15
};

export const EDITIONS_SIZE_PER_PAGE_LIST = [15, 30, 60, 100];

/*
 * An edition write answers 202 with a job rather than the edition, so every save is followed by a
 * poll. Sixty seconds is the same budget `pollJobUntilTerminal` defaults to; it is named here so the
 * page and its tests cannot drift apart.
 */
export const EDITION_JOB_POLL = {
	intervalMs: 1000,
	maxAttempts: 60
};
